import { DependencyUsage } from '../../../../shared/issuesV2';
import { CheckboxFilterGroup, FilterPanel } from '../../generic/Filter';

const FILTER_OPTIONS: Array<{ key: DependencyUsage, label: string }> = [
  { key: DependencyUsage.Direct, label: 'Direct' },
  { key: DependencyUsage.Deep, label: 'Transitive' },
];

export type DepthIssueFilterProps = {
  selectedOptions?: string[];
  onSelect: (key: string, selected: boolean) => void;
};

const DepthIssueFilter = ({ selectedOptions, onSelect }: DepthIssueFilterProps) =>
  <FilterPanel>
    <CheckboxFilterGroup
      title="Depth"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-depth-filters"
    />
  </FilterPanel>;

export default DepthIssueFilter;
